export class MockupInput {

//for applicationlist
	
APPLIST_REQUEST_INPUT = {
  "organizationid": "00CP000000kMAEc",
  "userid": "66jP000000qETRx",
  "username": "Admin",
  "data": {
    "pagination": true,
    "pagenum": 1,
    "pagesize": 10
  }
}

APP_REQUEST_INPUT = {
  "organizationid": "00CP000000kMAEc",
  "userid": "66jP000000qETRx",
  "username": "Admin",
  "data": {
    "application": {
      "id":""
    }
  }
}


}